import React, { useEffect, useState } from 'react'
import Header from '../components/home/Header';
import CategoriasCount from '../components/categorias/CategoriasCount';
import './Extratos.css'
import ValoresApi from '../services/robinhood/ValoresApi';
import ListaIndices from '../components/extratos/ListaIndices';
import ListaTransferencias from '../components/extratos/ListaTransferencias';
import ContentBoxValores from '../components/extratos/ContentBoxValores';
import { useLocation, useNavigate } from 'react-router-dom';
import MunicipioSelecionado from '../components/extratos/MunicipioSelecionado';
import MesSelecionado from '../components/extratos/MesSelecionado';
import ListaDadosBasicos from '../components/extratos/ListaDadosBasicos';
import CategoriasApi from '../services/robinhood/CategoriasApi';
import ListaDadosBasicosConservacao from '../components/extratos/ListaDadosBasicosConservacao';
import ListaDadosBasicosSaneamento from '../components/extratos/ListaDaddosBasicosSaneamento';
import MunicipioSelecionarModal from '../components/municipios/MunicipioSelecionarModal';
import ButtomRelatorio from '../components/extratos/ButtomRelatorio';
import TransferenciasGlobaisAnos from 'components/transferenciasGlobais/TransferenciasGlobaisAnos';
import ParametrosApi from 'services/robinhood/ParametrosApi';
import NoticiasNotificacao from 'components/noticias/NoticiasNotificacao';

export default function Extratos() {

    const location = useLocation();
    const mesAnterior = () => new Date().setMonth(new Date().getMonth() - 1);
    const [valoresIndices, setValoresIndices] = useState([]);
    const [valoresTransferencias, setValoresTransferencias] = useState([]);
    const [valoresDadosBasicos, setValoresDadosBasicos] = useState([]);
    const [valoresDadosBasicosConservacao, setValoresDadosBasicosConservacao] = useState([]);
    const [valoresDadosBasicosSaneamento, setValoresDadosBasicosSaneamento] = useState([]);
    const [valoresTableConservacoes, setValoresTableConservacoes] = useState([]);
    const [valoresTableSaneamentos, setValoresTableSaneamentos] = useState([]);
    const [valores, setValores] = useState([]);
    const [categorias, setCategorias] = useState(null);
    const [municipio, setMunicipio] = useState(localStorage.getItem('municipio') ? JSON.parse(localStorage.getItem('municipio')) : { 'id': null, 'municipio': null });
    const navigate = useNavigate();
    const [anos, setAnos] = useState(localStorage.getItem('valores_anos') ? JSON.parse(localStorage.getItem('valores_anos')) : [{ 'ano': new Date().getFullYear() }]);
    const [ano, setAno] = useState(new Date(mesAnterior()).getFullYear());
    const periodoRequest = location.state ? location.state.periodo : { 'mes_id': (new Date(new Date()).getMonth() + 1), 'ano': ano };
    const [periodo, setPeriodo] = useState(periodoRequest);

    useEffect(() => {
        if (!municipio.id) {
            navigate('/municipios');
        }
        new CategoriasApi().all().then(response => setCategorias(response));
        new ValoresApi().anos().then(response => {
            if (response) {
            localStorage.setItem('valores_anos', JSON.stringify(response.reverse()));
            }
        });
        localStorage.setItem('ano_selecionado', new Date().getFullYear());
    }, []);

    useEffect(() => {
        const parametrosApi = new ParametrosApi();
        parametrosApi.all().then(response => {
          response.map(parametro => {
            if (parametro.id == parametrosApi.logo_exibir) {
              localStorage.setItem('parametros_logo_exibir', JSON.stringify({ parametros_logo_exibir: parametro.valor }));
            }
            if (parametro.id == parametrosApi.logo_cinza) {
              localStorage.setItem('parametros_logo_cinza', JSON.stringify({ parametros_logo_cinza: parametro.valor }));
            }
            if(parametro.id == parametrosApi.periodo_mes_atual){
                localStorage.setItem('parametros_periodo_mes_atual', JSON.stringify({parametros_periodo_mes_atual: parametro.valor}))
            }
          });
        });
      }, []);

    useEffect(() => {
        document.getElementById('toggle-menu').className = 'theme-blush';
        scrollWindow();
        getValores();
    }, [location.state, ano]);

    useEffect(() => {
        getValores();
    }, [municipio])

    const getValores = async () => {
        await new ValoresApi().mesAnoMunicipioOrdenado(periodoRequest.mes_id, ano, municipio.id).then(response => {
            setPeriodo(response.periodo);
            setValores(response.valores);
            setValoresIndices(response.valores.indices);
            setValoresTransferencias(response.valores.transferencias);
            setValoresDadosBasicos(response.valores.dados_basicos);
            setValoresDadosBasicosSaneamento(response.valores.dados_basicos_saneamentos);
            setValoresTableSaneamentos(response.table_saneamentos);
            setValoresDadosBasicosConservacao(response.valores.dados_basicos_unidades_conservacoes);
            setValoresTableConservacoes(response.table_conservacoes);
        });
    }

    const handlerMunicipio = (_municipio) => {
        if (!_municipio.id) {
            return;
        }
        setMunicipio(_municipio);
        localStorage.setItem('municipio', JSON.stringify(_municipio));
        const storage = JSON.parse(localStorage.getItem('municipios'));
        const municipiosFilter = storage.filter(item => item.id != _municipio.id);
        municipiosFilter.push(_municipio);
        municipiosFilter.reverse();
        localStorage.setItem('municipios', JSON.stringify(municipiosFilter));
    }

    const handlerAno = (_ano) => {
        setAno(_ano);
    }

    const scrollWindow = () => {
        let mybutton = document.getElementById("buttomScrollUp");
        window.onscroll = function () { scrollFunction() };
        function scrollFunction() {
            if (document.documentElement.scrollTop > 60) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
            }
        }
    }

    const topFunction = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <div className='container-fluid'>
            <Header>
                {/* {`Periodo: ${JSON.stringify(periodo)}`}
                <br/>
                {`Periodo Request: ${JSON.stringify(periodoRequest)}`}
                <br/>
                {`Mes Anterior: ${JSON.stringify(mesAnterior)}`} */}
                <div className='row'>
                    <div className='col-8'><h5 style={{ marginLeft: '10px', marginBottom: '20px' }}> <i className='zmdi zmdi-city-alt'></i> DADOS DO MUNICÍPIO  </h5></div>
                    <div className='col-4' style={{ bottom: '-20px', color: 'gray' }}><h6>EXTRATOS</h6></div>
                </div>

                <section className='container-fluid'>
                    <div className='row'>
                        <MunicipioSelecionado municipio={municipio} />
                        <MesSelecionado periodo={periodo} />

                        <ButtomRelatorio location={'/extratos/anual'} titulo={'ANUAL'} subtitulo={'TODOS OS MESES DO ANO'} />
                        <ButtomRelatorio location={'/extratos/comparativo/transferencia'} titulo={'COMPARATIVO'} subtitulo={'COMPARAR MUNICÍPIOS'} />

                    </div>
                </section>

                <TransferenciasGlobaisAnos anos={anos} handlerAno={handlerAno} ano={ano} backgroundColor={'bg-blue-grey'} demaisAnosUrl={'http://robin-hood-historico.fjp.mg.gov.br'} retornar={false} />

                <CategoriasCount categorias={categorias} valores={{
                    'indices': valoresIndices.length,
                    'transferencias': valoresTransferencias.length,
                    'dadosBasicos': valoresDadosBasicos.length,
                    'dadosBasicosSaneamento': valoresDadosBasicosSaneamento.length,
                    'dadosBasicosConservacao': valoresDadosBasicosConservacao.length,
                    'valoresTableConservacoes': valoresTableConservacoes,
                }} />
                {valoresIndices.length == 0 &&
                    valoresTransferencias.length == 0 && valoresDadosBasicos.length == 0 && valoresDadosBasicosConservacao.length == 0 && valoresDadosBasicosSaneamento.length == 0 ? <h6 className='m-l-20 text-muted'><i class="zmdi zmdi-info"></i>  NÃO FORAM ENCONTRADOS DADOS REFERENTES AO PERÍODO SELECIONADO</h6> : null}
            </Header>

            <section class="content" style={{ marginTop: '-5px' }}>
                {/*<NoticiasNotificacao></NoticiasNotificacao>*/}
                <div className=''>
                    {valoresTransferencias.length > 0 &&
                        <ContentBoxValores titulo="TRANSFERÊNCIAS" subtitulo={`TRANSFERÊNCIAS DO MUNICÍPIO DE ${municipio.municipio} NO PERÍODO ${periodo.mes_id}/${periodo.ano}`} color='yellowgreen'>
                            <ListaTransferencias valores={valoresTransferencias} exibirTotal={true} key={Math.random()}></ListaTransferencias>
                        </ContentBoxValores>}
                    {valoresIndices.length > 0 &&
                        <ContentBoxValores titulo="ÍNDICES" subtitulo={`ÍNDICES DO MUNICÍPIO DE ${municipio.municipio} NO PERÍODO ${periodo.mes_id}/${periodo.ano}`} color='pink'>
                            <ListaIndices valores={valoresIndices} key={Math.random()}> </ListaIndices>
                        </ContentBoxValores>}
                    {valoresDadosBasicos.length > 0 &&
                        <ContentBoxValores titulo="DADOS BÁSICOS" subtitulo={`DADOS BÁSICOS DO MUNICÍPIO DE ${municipio.municipio} NO PERÍODO ${periodo.mes_id}/${periodo.ano}`} color='purple'>
                            <ListaDadosBasicos valores={valoresDadosBasicos} key={Math.random()}></ListaDadosBasicos>
                            {/* {valoresDadosBasicosSaneamento.length > 0 &&
                                <>
                                    <br />
                                    <hr />
                                    <p style={{ fontSize: '15px;', fontWeight: 600, color: ' black', }}> DADOS REFERENTES A SANEAMENTO </p>
                                    <ListaDadosBasicosSaneamento table={valoresTableSaneamentos} key={Math.random()} ></ListaDadosBasicosSaneamento>
                                </>
                            } */}

                        </ContentBoxValores>}
                    {valoresDadosBasicosSaneamento.length > 0 &&
                        <ContentBoxValores titulo="SANEAMENTO" subtitulo={`DADOS DE SANEAMENTO DO MUNICÍPIO DE ${municipio.municipio} NO PERÍODO ${periodo.mes_id}/${periodo.ano}`} color='blue'>
                            <ListaDadosBasicosSaneamento table={valoresTableSaneamentos} key={Math.random()} ></ListaDadosBasicosSaneamento>
                        </ContentBoxValores>}
                    {valoresDadosBasicosConservacao.length > 0 &&
                        <ContentBoxValores titulo="UNIDADES DE CONSERVAÇÃO" subtitulo={`UNIDADES DE CONSERVAÇÃO DO MUNICÍPIO DE ${municipio.municipio} NO PERÍODO ${periodo.mes_id}/${periodo.ano}`} color='#FCCC1A'>
                            <ListaDadosBasicosConservacao table={valoresTableConservacoes} key={Math.random()}></ListaDadosBasicosConservacao>
                        </ContentBoxValores>}
                </div>
            </section >
            <MunicipioSelecionarModal titulo='ALTERAR MUNICÍPIO' handlerMunicipio={handlerMunicipio} navigate={''} />

            <a onClick={topFunction} id="buttomScrollUp" className='btn btn-rouded  waves-effect'>
                <i className='zmdi zmdi-caret-up-circle' style={{ marginTop: '0px', paddingTop: '-10px' }}></i>
            </a>
        </div>
    )
}